import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    paddingTop: theme.spacing(4),
  },
  headingBar: {
    paddingLeft: theme.spacing(2),
  },
  checkbox: {
    "& span": {
      fontSize: theme.typography.body2.fontSize,
    },
  },
  searchIcon: {
    color: theme.palette.secondary.main,
  },
  searchField: {
    "& input": {
      fontSize: theme.typography.body2.fontSize,
    },
  },
  removeButtonOld: {
    marginLeft: theme.spacing(1.35),
    marginRight: theme.spacing(1),

    "& svg": {
      color: theme.palette.secondary.main,
      transition: "all 0.3s",
    },

    "&:disabled": {
      "& svg": {
        color: theme.palette.grey[500],
      },
    },
  },
  removeButton: {
    marginLeft: theme.spacing(1),
    color: theme.palette.grey[700],
    borderRadius: 8,
    fontSize: 14,
    padding: 5,
    "& svg": {
      color: theme.palette.grey[700],
      transition: "all 0.3s",
      marginRight: 8,
    },

    "&:disabled": {
      "& svg": {
        color: theme.palette.grey[500],
      },
    },
  },
  selectsBar: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(1),
  },
  selectLabel: {
    marginRight: theme.spacing(1),
  },
  select: {
    marginRight: theme.spacing(3),
  },
  progressContainer: {
    padding: theme.spacing(5),
  },
}));

export default useStyles;
